import { useState } from 'react';

/**
 * 健診分數方法論（Batch 6-B2，折疊式）。
 * 只說明分數「怎麼算」的概念，不公開內部演算法程式碼 / Backend Logic / API Key。
 */
export default function ReportMethodologySection() {
  const [open, setOpen] = useState(false);

  return (
    <section className="ds-container pt-16 md:pt-20">
      <div className="rounded-2xl border border-background-300 bg-background-50 shadow-card">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          className="flex w-full cursor-pointer items-center justify-between gap-3 px-5 py-5 text-left"
        >
          <span className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-50 text-primary-700">
              <i className="ri-book-open-line text-xl" />
            </span>
            <span className="text-lg font-bold text-foreground-950 md:text-xl">健診分數怎麼計算？</span>
          </span>
          <i className={`${open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-2xl text-foreground-400`} />
        </button>

        {open && (
          <div className="border-t border-background-200 px-5 pb-6 pt-5">
            <div className="rounded-xl border border-accent-200 bg-accent-50/70 p-4">
              <p className="flex items-center gap-2 text-base font-bold text-accent-900">
                <i className="ri-shield-check-line text-lg" />
                天地人網自訂 Google 商家公開資料健康度
              </p>
              <p className="mt-2 text-sm leading-relaxed text-accent-800 md:text-base">
                這不是 Google 官方評分、Google 官方排名、SEO Ranking，也不是 Google 官方商家檔案健診。
              </p>
            </div>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              本健診依商家公開資料完整度、評分與評論表現、以及可取得的同業比較資料，以天地人網自訂評分模型計算。
            </p>
            <p className="mt-3 text-base leading-relaxed text-foreground-600">
              資料不足的項目不會直接視為 0 分；系統會依實際可評分權重重新計算健康度。
            </p>
            <p className="mt-3 text-base leading-relaxed text-foreground-600">
              健康度分數反映本次可取得的公開商家資料與同業比較結果。高分不代表 Google
              搜尋排名保證；低分也不代表商家實際經營品質不佳，而是表示目前公開資料中仍有可改善的項目。
            </p>
            <p className="ds-badge mt-4 bg-primary-50 text-primary-800 ring-1 ring-primary-200">
              <i className="ri-list-check-2" />
              共 11 項指標，總基準權重 100 分。
            </p>
          </div>
        )}
      </div>
    </section>
  );
}